import React from 'react';
import Launch_empty_stateFP from '../FullPagesComponents/Interaction/Launch_empty_stateFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import { example_one, example_Two } from '../../../utils/DictionaryManagementUtils';

//= ========================================================================
const Launch_empty_stateDF = ({
  globJSON,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <SimulatorsViewerArrangement>
    <Launch_empty_stateFP
      globJSON={globJSON}
      language={language}
      simPlatform={simPlatform}
      slideshowRefs={slideshowRefs}
      TopTitle={example_one}
    />
    <Launch_empty_stateFP
      globJSON={globJSON}
      language={language}
      simPlatform={simPlatform}
      slideshowRefs={slideshowRefs}
      TopTitle={example_Two}
      withoutBlueScreen
    />
  </SimulatorsViewerArrangement>
);

export default Launch_empty_stateDF;
